module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.classObject,
    attrs: {
      "type": "button",
      "aria-label": _vm.label
    },
    on: {
      "click": _vm.onclick
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed0c8a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/nav-toggle.vue
// module id = 265
// module chunks = 0